import FormField, { FormFieldProps, readValue, writeValue } from "./FormField";
import React, { ChangeEvent, Component } from "react";
import Strings from "@my-dld/assets/strings";
import CurrencyConverter from "./Converters/CurrencyConverter";
import { CurrencyUtil, StringUtil } from "@eres/core";
import { getInputStyle } from "./TextInputField";

interface Props extends FormFieldProps<string> {
	containerClassName?: string;
	inputGroupClassName?: string;
	inputClassName?: string;
	currencyTypeClassName?: string;
	errorInputClass?: string;
	placeHolder?: string;
	currencyType?: string;
}

interface State {
	isFocus: boolean;
}

class CurrencyInput extends Component<Props, State> {
	static defaultProps: Partial<Props> = {
		inputGroupClassName: "input-group-prepend",
		inputClassName: "form-control",
		currencyTypeClassName: "input-group-text",
		errorInputClass: "form-input-error is-invalid",
	};

	constructor( props: Props ) {
		super( props );
		this.state = {
			isFocus: false,
		};
	}

	onChange = ( e: ChangeEvent<HTMLInputElement> ) => {
		const target = e.target;
		let pVal = "" + readValue( this.props );
		let cVal = "" + CurrencyConverter.toData( target.value );
		let pc = target.selectionStart;
		if ( this.props.onValueChange )
			this.props.onValueChange( cVal );
		writeValue( this.props, cVal, () => {
			let selectionStart = CursorPositioner( pVal, pc ? pc : 0, cVal );
			target.selectionStart = selectionStart;
			target.selectionEnd = selectionStart;
		} );
	};

	render() {
		const {
			id, inputClassName, placeHolder, error, errorInputClass, disabled, currencyType,
			inputGroupClassName, currencyTypeClassName, required
		} = this.props;
		let value = readValue( this.props );
		let cValue = value ? "" + CurrencyConverter.toText( value ) : "";
		let inputStyle = getInputStyle( this.state.isFocus, required, cValue, error );
		const inpProps = {
			id: id,
			value: cValue,
			onChange: this.onChange,
			className: inputClassName + inputStyle + ( error ? ` ${ errorInputClass }` : "" ),
			placeholder: placeHolder,
			type: "text",
			disabled: disabled,
			onFocus: this.onFocus,
			onBlur: this.onBlur,
		};
		return (
			<FormField { ...this.props }>
				<div className="input-group">
					<input { ...inpProps } disabled={ disabled }/>
					{ currencyType && <div className={ inputGroupClassName }>
						<span className={ currencyTypeClassName }>{ Strings.aed }</span>
					</div> }
				</div>
			</FormField>
		);
	}

	private onFocus = () => {
		this.setState( { isFocus: true } );
	};

	private onBlur = () => {
		this.setState( { isFocus: false } );
	};
}

export function CursorPositioner( previousValue: string | null, previousPosition: number, value: string ): number {
	if ( StringUtil.isEmptyStringOrNull( previousValue! ) )
		return 1;
	let p = CurrencyUtil.convertValueToCurrency( previousValue! )!;
	let c = CurrencyUtil.convertValueToCurrency( value! )!;
	c = c ? c : "";
	p = p ? p : "";
	let inc = p.split( "," ).length - 1;
	let ouc = c.split( "," ).length - 1;
	if ( p === c ) return previousPosition - 1;
	if ( inc !== ouc ) {
		if ( inc < ouc ) return previousPosition + 1;
		if ( inc > ouc ) return previousPosition - 1;
	}
	return previousPosition;
}

export default CurrencyInput;
